export default "__VITE_ASSET__BsX2exlz__"